<template>
  <div id="rodape" class="pa-5 d-flex border-top">
    <v-spacer />

    <SysBotao v-text="'Cancelar'" background="white" @click="$emit('cancelar', {})" />

    <SysBotao
      v-text="'Gerar Relatório'"
      background="#142454"
      color-texto="white"
      class="ml-3 font-16"
      radius="8"
      :disabled="!dados_gerar_relatorio.categorias_selecionadas || dados_gerar_relatorio.categorias_selecionadas.length === 0"
      @click="gerarRelatorioTeste()"
    />

    <form
      :action="URL"
      method="post"
      target="_blank"
      ref="button-form-relatorio-analise-cotacao"
    >
      <input type="text" hidden name="categorias_selecionadas" :value="CATEGORIAS_SELECIONADAS" />
      <input type="text" hidden name="cotacoes_para_analise" :value="DADOS_COTACAO" />
    </form>
  </div>
</template>

<script>
import { verificarExportarRelatorioAnaliseCotacoes } from "@/api/compraPorDepartamentos/PedidoCompraTipo"
import SysBotao from "../../../utils/botoes/SysBotao";
import $axios from "@/api/api.js";

export default {
  name: "RodapeDialog",
  props: {
    dados_gerar_relatorio: {
      typeof: Array,
      default: () => []
    }
  },
  components: {
    SysBotao
  },
  computed: {
    URL() {
      return $axios.defaults.baseURL + '/pedidos-compra-departamentos/analise-cotacao/gerar-exportacoes-winthor';
    },
    CATEGORIAS_SELECIONADAS () {
      if (this.dados_gerar_relatorio.categorias_selecionadas) {
        return JSON.stringify(this.dados_gerar_relatorio.categorias_selecionadas.map(m => JSON.parse(m)));
      }
      return [];
    },
    DADOS_COTACAO() {
      if (this.dados_gerar_relatorio.cotacoes_para_analise && this.dados_gerar_relatorio.cotacoes_para_analise.dados_importacao) {
        return JSON.stringify(this.dados_gerar_relatorio.cotacoes_para_analise.dados_importacao)
      }
      return [];
    }
  },
  methods: {
    gerarRelatorioTeste() {
      const params = {
        categorias_selecionadas: this.CATEGORIAS_SELECIONADAS,
        cotacoes_para_analise: this.DADOS_COTACAO
      }

      this.$store.dispatch('loading/addRequisicao',
        verificarExportarRelatorioAnaliseCotacoes(params)
          .then((validacao) => {
            this.$emit('resetar-dialog', validacao);
            this.$refs['button-form-relatorio-analise-cotacao'].submit();
          })
      );
    }
  }
}
</script>

<style scoped>
#rodape {
  position: absolute;
  top: auto;
  bottom: 0;
  width: 100%;
}
.border-top {
  border-top: 1px solid #e0d9d9;
}
</style>
